import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  layout: {
    "& .MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
      position: "absolute",
      right: "41px",
    },
  },
  dialogContent: {
    textAlign: "center",
  },
  deleteBtn: {
    position: "absolute",
    top: -50,
    right: 0,
  },
  step: {
    height: "100%",
    "&.show": {
      display: "block",
    },
    display: "none",
    "& .MuiFormControl-root.disabled": {
      background: "#dcdcdc",
    },
  },
  step1From: {
    display: "flex",
    justifyContent: "center",
    margin: "auto 200px",
  },
  projects: {
    display: "flex",
    flex: 1,
    justifyContent: "flex-end",
    marginRight: 15,
    "& input:not(:placeholder-shown) + .MuiAutocomplete-endAdornment .MuiAutocomplete-clearIndicator":
      {
        visibility: "unset",
      },
  },
  chantiers: {
    display: "flex",
    flex: 1,
    justifyContent: "flex-start",
  },
  content: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    marginTop: "5px !important",
    marginBottom: "5px !important",
  },
  paper: {
    flexDirection: "column",
  },
  circularProgress: {
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  select: {
    flex: "0 1 400px",
    background: theme.color.white,
    "& .MuiInputLabel-shrink": {
      background: `${theme.color.white} !important`,
    },
  },
  title: {
    margin: 0,
    marginLeft: 5,
  },
  form: {
    flex: 1,
  },
}));
